import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { CardActionArea } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from '../config/firebase.js';
import { useState, useEffect } from 'react';

//just for testing the components
import chipsJPG from '../chips1.jpg';


export default function DishCard({dishInfo, categoryName, categoryPosition, refreshParent}) {

  let {
    name,
    id,
    imagePath,
    description,
    price,
    ingredients,
    available_extras,
    category,
    position
  } = dishInfo;

  dishInfo.categoryPosition = categoryPosition

  const navigate = useNavigate();

  const pageURL = '/edit-menu/' + categoryName + '/' + name;

  const handleDishDelete = async () => {
    
    try {
      const res = await fetch(`/menu/delete_dish/${categoryPosition}/${position}`, {
        method: 'DELETE',
      })
      refreshParent();
    } catch (err) {
      console.log(categoryPosition + position);
      console.log(err.message);
    }
  };

  const handleDishIncrement = async () => {
    
    try {
      const res = await fetch(`/menu/increment_dish?category_position=${categoryPosition}&dish_position=${position}`, {
        method: 'PUT'
      })
      refreshParent();
    } catch (err) {
      console.log(categoryPosition + position);
      console.log(err.message);
    }
  };

  const handleDishDecrement = async () => {
    const body = {
      category_position: categoryPosition,
      dish_position: position
    }
    try {
      const res = await fetch(`/menu/decrement_dish?category_position=${categoryPosition}&dish_position=${position}`, {
        method: 'PUT'
      })
      refreshParent();
    } catch (err) {
      console.log(categoryPosition + position);
      console.log(err.message);
    }
  };

  const fetchImageUrl = async (path) => {
    const storageRef = ref(storage, path);
  
    try {
      const url = await getDownloadURL(storageRef);
      return url;
    } catch (error) {
      console.error("Error fetching image URL:", error);
      return null;
    }
  };


  const [dishImage, setDishImage] = useState("");
  useEffect(() => {
    const get_dish_image = async () => {
      const url = await fetchImageUrl(imagePath);
      setDishImage(url);
    };

    get_dish_image();
  }, [])
  // console.log(dishImage)
  return (
    <Card sx={{maxWidth: { sx:1, sm: 2/3, lg: 1/3}, m:1}} >
      <CardActionArea>
        <Box sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            }}
            // onClick={() => navigate(pageURL,  { state: { dishInfo } })}
        >
          <CardMedia
            component="img"
            sx = {{
              width: 1/3,
              bgColor: 'lightgray'
            }}
            image={dishImage}
            alt={"picture of " + name}
          />
          <CardContent>
            <Typography gutterBottom variant="h5" component="div">
              {name}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              ${price}
            </Typography>
          </CardContent>
        </Box> 
        <Box sx={{
          w: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>    
        <Button
          variant="text"
          color="primary"
          onClick={handleDishDecrement}
          sx={{
            color:'black',
            '&:hover': {
              backgroundColor: 'transparent',
              transform: 'scale(1.3)',
              transition: 'transform 0.3s'
            }
          }}
        >
          ↑
        </Button>
        <Button
          variant="text"
          color="primary"
          onClick={handleDishIncrement}
          sx={{
            color:'black',
            '&:hover': {
              backgroundColor: 'transparent',
              transform: 'scale(1.3)',
              transition: 'transform 0.3s'
            }
          }}
        >
          ↓
        </Button>
        <Button
          variant="text"
          color="primary"
          onClick={handleDishDelete}
          sx={{
            color:'black',
            '&:hover': {
              backgroundColor: 'transparent',
              transform: 'scale(1.3)',
              transition: 'transform 0.3s'
            }
          }}
        >
          🗑
        </Button>
        <Button
          variant="text"
          color="primary"
          onClick={() => navigate(pageURL,  { state: { dishInfo } })}
          sx={{
            color:'black',
            '&:hover': {
              backgroundColor: 'transparent',
              transform: 'scale(1.3)',
              transition: 'transform 0.3s'
            }
          }}
        >
          ✎
        </Button>
        </Box>  
      </CardActionArea>
    </Card>
  );
}